import React from 'react'
import { FEEDBACK_DEFAULTS, MODULE_KEYS } from '../../moduleRegistry'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { Heading } from '../HeadingModule/Heading'
import { Subheading } from '../HeadingModule/Subheading'

/** Thank-you state shown after feedback is submitted. Reuses the shared header styles. */
export const FeedbackCompleted = () => {
  const { completedHeading, completedSubheading } = useModuleConfig(MODULE_KEYS.feedback, FEEDBACK_DEFAULTS)

  return (
    <header className="expanded-feedback-module__header" data-testid="expanded-feedback-completed">
      <Heading as="h2" id="expanded-feedback-heading" className="expanded-feedback-module__heading" text={completedHeading} />
      <Subheading className="expanded-feedback-module__subheading" text={completedSubheading} />
    </header>
  )
}
